import { Component, Input, AfterViewChecked, ChangeDetectionStrategy } from '@angular/core'
import { Router } from '@angular/router'
import { MenuItems, MenuService } from '../../configs/menu.service'
import { CoreService } from '../../services'
import { TranslateService } from '@ngx-translate/core'
declare let $: any

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SideMenuComponent implements AfterViewChecked {
  @Input() isShown = false
  public menuItems: MenuItems[] = []
  public isMenuReady = false
  menuWasCheckedOnInit = false

  constructor(
    private router: Router,
    private core: CoreService,
    private menuService: MenuService,
    private translateService: TranslateService
  ) {
    this.core.services.user.currentUserEmitter.subscribe().then(user => {
      if (user?.id) {
        this.menuItems = this.menuService.menuItems(this.core.services.user)
        this.isMenuReady = true
        this.isShown = true
        // setTimeout(() => $('[data-widget="treeview"]').Treeview('init'), 0)
      } else {
        this.menuItems = []
        this.isMenuReady = false
        this.isShown = false
      }
    })
    this.translateService.onLangChange.subscribe(ev => {
      this.menuItems = this.menuService.menuItems(this.core.services.user)
    })
  }
  ngAfterViewChecked() {
    if (this.menuWasCheckedOnInit || !this.isMenuReady) {
      return
    }
    const activeSubmenu = document.querySelector('.nav-item .active-submenu')
    if (activeSubmenu) {
      setTimeout(() => {
        const liParent = activeSubmenu.closest('.has-treeview')
        liParent?.classList.add('menu-open')
        liParent?.querySelector('.nav-link:not(.nav-link-sub)')?.classList.add('active')
      }, 0)
      // for the changes to be applied asyncronously, but with zero delay
    }
    this.menuWasCheckedOnInit = true
  }
  public handleSubtree(event: Event) {
    event.preventDefault()
    const a = event.currentTarget as HTMLAnchorElement
    const li = a.closest('.nav-item')
    if (!li) {
      return
    }
    if (li.classList.contains('menu-open')) {
      li.classList.remove('menu-open')
      setTimeout(() => li.classList.remove('menu-is-opening'), 500)
      return
    }
    if (li.classList.contains('has-treeview')) {
      li.classList.add('menu-is-opening')
      setTimeout(() => li.classList.add('menu-open'), 0)
    }
    ;[...li.closest('ul').querySelectorAll(':scope > li')]
      .filter(li => li.classList.contains('menu-open'))[0]
      ?.querySelector('a')
      ?.click()
  }
  public isActiveLink(item: MenuItems) {
    const link = item.link?.[0]
    if (!link) {
      return false
    }
    if (link === this.router.url) {
      return true
    }
    // List links (e.g. '/checkouts') are single path segments; their detail route lives at the
    // singular form of the same word (e.g. '/checkout/123'), not nested under the list path. Keep
    // the list item highlighted while viewing one of its entities' detail pages instead of going
    // dark as soon as you leave the exact list URL. Only single-segment links are eligible, so
    // this can't misfire on multi-segment links (e.g. '/print/purchase-exports') that just happen
    // to share a first segment with a sibling menu item.
    const linkSegments = link.split('/').filter(Boolean)
    if (linkSegments.length !== 1) {
      return false
    }
    const urlFirstSegment = this.router.url.split('/').filter(Boolean)[0] ?? ''
    return this.singularize(linkSegments[0]) === this.singularize(urlFirstSegment)
  }
  public isParentActive(item: MenuItems): boolean {
    return !!item.sublinks?.some(subitem => this.isActiveLink(subitem))
  }
  private singularize(segment: string): string {
    if (segment.endsWith('ies')) {
      return segment.slice(0, -3) + 'y'
    }
    if (segment.endsWith('s') && !segment.endsWith('ss')) {
      return segment.slice(0, -1)
    }
    return segment
  }
}
